import React from "react";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "../typography";
import "../sda/styles.scss";
import { Link } from "@amzn/stencil-react-components/link";

const documentLink = (
  <Link
    target="_blank"
    href="https://www.uscis.gov/i-9-central/form-i-9-acceptable-documents"
  >
    here
  </Link>
);

const supportLink = (
  <Link target="_blank" href="https://hiring.amazon.com/accommodations">
    here
  </Link>
);

interface PreHireAppointmentDetailsProps {
  nheDate: string;
  nheTimeRange: string;
  address: string;
}

export const PreHireAppointmentDetails = ({
  nheDate,
  nheTimeRange,
  address,
}: PreHireAppointmentDetailsProps) => {
  return (
    <>
      <Col gridGap="2rem">
        <Row>
          <Col gridGap="0.5rem">
            <Text fontSize="T300">Appointment details</Text>
            <Text>Date: {nheDate}</Text>
            <Text fontSize="T100">
              Visit us for a 30 minute session anytime between {nheTimeRange}
            </Text>
            <Text>Venue: {address}</Text>
          </Col>
        </Row>
        <Row>
          <Col gridGap="0.5rem">
            <Text fontSize="T300">Things to bring</Text>
            <Text>Original unexpired photo ID</Text>
            <Text>Original unexpired work authorization document</Text>
            <Text fontSize="T100">
              Click {documentLink} for a complete list of acceptable documents.
            </Text>
          </Col>
        </Row>
        <Row>
          <Col gridGap="1rem">
            <Col gridGap="0.5rem">
              <Text fontSize="T300">Special assistance</Text>
              <Text>
                If you require any accommodations, such as an ASL interpreter
                for the hiring event, please click {supportLink} and chat with
                us to request an interpreter. Please contact us immediately upon
                scheduling your appointment. We need at least 48 hours prior to
                your appointment to make arrangements.
              </Text>
            </Col>
          </Col>
        </Row>
      </Col>
    </>
  );
};
